import {
  ResultAction,
  ResultActionMethods,
  WindowNames,
} from '@cashier/cashier-model';
import { convertToUrl, ProviderWindowService } from '@cashier/cashier-shared';

interface ToPaymentProgressConfigurationInput {
  resultAction: ResultAction;
  loadingPageUrl: string;
}

interface PaymentProgressConfiguration {
  handleFallbackInitiated: (submitForm: () => void) => void;
  applyAction: (
    sendRequest: (
      method: ResultActionMethods,
      url: string,
      data: { [key: string]: string },
    ) => void,
    renderContent: (content: string) => void,
  ) => void;
}

export const toPaymentProgressConfiguration = ({
  resultAction,
  loadingPageUrl,
}: ToPaymentProgressConfigurationInput): PaymentProgressConfiguration => {
  const { url, method, output, parameters } = resultAction;

  const applyAction = (
    sendRequest: (
      method: ResultActionMethods,
      url: string,
      data: { [key: string]: string },
    ) => void,
    renderContent: (content: string) => void,
  ) => {
    //TODO: think about what to do if both 'url' and 'output' are presented
    if (url) {
      sendRequest(method, url, parameters);
    }

    if (output) {
      renderContent(output);
    }
  };

  const handleFallbackInitiated = (onSubmitForm: () => void): void => {
    ProviderWindowService.initialize(WindowNames.Window, loadingPageUrl);

    if (url) {
      ResultActionMethods.POST === method
        ? onSubmitForm()
        : ProviderWindowService.redirect(convertToUrl(url, parameters));
      return;
    }

    if (output) {
      ProviderWindowService.writeContent(WindowNames.Window, output);
    }
  };

  return {
    handleFallbackInitiated,
    applyAction,
  };
};
